import styled from "@emotion/styled";
import { Icon } from "@mui/material";
import React from "react";
import Badge from "../../General/Badge";

const CardContainer = styled.div`
    height: inherit;
    border-radius: 10px;
    border: 1px solid var(--outlined-primary, #d9d9d9);
    background-color: var(--color-white);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    gap: 1rem;
    padding: 2rem;
    transition: background-color 0.3s ease-in-out;
    &:hover {
        background-color: var(--color-primary-light);
        box-shadow: 10px 10px rgba(0, 0, 0);
        cursor: pointer;
        .badge-style {
            color: white;
            background-color: var(--color-primary-main);
        }
    }
`;

function CardFeaturedJobs({ title, level, location, departement, onClick }) {
    return (
        <CardContainer onClick={onClick}>
            <div className="text-department">
                <Badge className="badge-style">
                    <b className="text-departement">{departement}</b>
                </Badge>
            </div>
            <h5 className="text-title-change">{title}</h5>
            <div className="d-flex flex-column gap-1">
                <div className="d-flex align-items-center gap-1">
                    <Icon
                        className="material-icons-outlined color-grey"
                        style={{ fontSize: "28px" }}>
                        stacked_line_chart
                    </Icon>
                    <div className="text-desc d-flex flex-column">
                        <p className="color-grey">Tingkat Pengalaman</p>
                        <h6>{level}</h6>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-1">
                    <Icon
                        className="material-icons-outlined color-grey"
                        style={{ fontSize: "28px" }}>
                        location_on
                    </Icon>
                    <div className="text-desc d-flex flex-column">
                        <p className="color-grey">Lokasi</p>
                        <h6>{location}</h6>
                    </div>
                </div>
            </div>
        </CardContainer>
    );
}

export default CardFeaturedJobs;
